module.exports = __webpack_public_path__ + "01700e3d9261c8e5f2b33b79e47fdfe0.pdf";